
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sykmeldt",
      function () {
        return require("private-next-pages/sykmeldt/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sykmeldt"])
      });
    }
  